var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRestore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1429 0C13.7329 0 10.4627 1.35459 8.05148 3.76577C5.6403 6.17695 4.28571 9.44722 4.28571 12.8571H0L5.55714 18.4143L5.65714 18.6143L11.4286 12.8571H7.14286C7.14286 7.32857 11.6143 2.85714 17.1429 2.85714C22.6714 2.85714 27.1429 7.32857 27.1429 12.8571C27.1429 18.3857 22.6714 22.8571 17.1429 22.8571C14.3857 22.8571 11.8857 21.7286 10.0857 19.9143L8.05714 21.9429C9.24774 23.14 10.6636 24.0896 12.2229 24.7369C13.7823 25.3842 15.4545 25.7164 17.1429 25.7143C20.5528 25.7143 23.823 24.3597 26.2342 21.9485C28.6454 19.5373 30 16.2671 30 12.8571C30 9.44722 28.6454 6.17695 26.2342 3.76577C23.823 1.35459 20.5528 5.08119e-08 17.1429 0ZM15.7143 7.14286V14.2857L21.8286 17.9143L22.8571 16.1857L17.8571 13.2143V7.14286H15.7143Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestore);
export default __webpack_public_path__ + "static/media/restore.3b28c79f.svg";
export { ForwardRef as ReactComponent };